import { YOO_FINDS_CDN } from "@/common";
const ROOT = `${YOO_FINDS_CDN}/h5/creatorLeaderboard`;
export const CREATOR_LEADERBOARD_LOGO = `${ROOT}/logo.png`;
export const CREATOR_LEADERBOARD_COPY = `${ROOT}/copy.png`;
